import React, { useEffect, useMemo, useState } from 'react'
import PdfReader from '../../pures/adobePfdReader/PdfReader'
import { BoxSomeHeadersGLPure, ButtonHLPure, ChatBoxGLPure, SimpleLoading, HeaderHLPure, GridSelectionHLPure, DialogSystemGLPure, DialogPdfHLPure, ButtonAddHLPure, InputHLPure, PromotionalFooterPure } from '../../pures'
import { Grid } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { LocalStorageService } from '../../../services'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import './assemblies-detail.view.css'
import { Tooltip } from "@progress/kendo-react-tooltip";
import { ArrowBtnMobile, newProfileIcon } from '../../../assets/logos/icons'
import moment from 'moment';
import { convertToStandarDate } from '../../../utils'
import { ProfileValidator } from '../../../validators'
import { useMediaQuery } from "@material-ui/core";

/**
 * @typedef {object} Props
 * @property {string} name
 */

/**
 * @param {Props} props.name
 * @return {JSX.Element} 
*/

const HeaderColumns = (props) => {
  return <span className={(props.title === props.t("assembliesDetailView.grid.title.1")) ? "grid-header-one" : "grid-headers"}>{props.title}</span>;
};

const CellColumnName = (props) => {
  return (
    <td>
      <div className='grid-cell-double-container-margin-left'>
        <p className='grid-cell-titles'>{props.dataItem.representativeName}</p>
        <p className='grid-cell-subtitles'>{props.dataItem.email}</p>
      </div>
    </td>
  )
}

const CellColumnType = (props) => {
  return (
    <td>
      <div>
        <p className="grid-cell-subtitles">{props.dataItem.type}</p>
      </div>
    </td>
  );
};

const CellColumnDate = (props) => {
  return (
    <td>
      <div>
        <p className="grid-cell-subtitles">{props.dataItem.dateFormatted}</p>
      </div>
    </td>
  );
};

const CellColumnAttendance = (props) => {
  return (
    <td>
      <div>
        <p className="grid-cell-subtitles">{props.dataItem.attendanceValue}</p>
      </div>
    </td>
  );
};

const CellColumnBtns = (props) => {
  return (
    ((!props.dataItem.id || props.dataItem.id === 0) && props.statusWorkflow === Number(process.env.REACT_APP_WORKFLOW__ASSEMBLY_STATUS_316110)) ? (
      <td>
        <div className="grid-btn-div">
          <button className="grid-btn-action" onClick={() => {
            props.setPoneNewGuest(props.dataItem.phone)
            props.setEmailNewGuest(props.dataItem.email)
            props.setNameNewGuest(props.dataItem.representativeName)
            props.setGuestIndex(props.columnIndex)
            props.setShowModalAddGuest(true)
          }
          }>
            <p>Editar</p>
          </button>
          <Tooltip
            openDelay={600}
            position="top"
            anchorElement="target"
            tooltipClassName="tooltipGeneralStyle"
          >
            <button
              className="cellActions-TrashBtn"
              onClick={() => props.deleteGuest(props.dataItem)}
            >
              <i
                title={""}
                className="k-icon k-i-delete k-i-trash"
              ></i>
            </button>
          </Tooltip>
        </div>
        <div className="grid-btn-arrow" onClick={() => props.deleteGuest(props.dataItem)}>
          <img alt="assemblies-arrow" src={ArrowBtnMobile} />
        </div >
      </td >

    ) : <td></td>

  );
};

const CellColumnBtns140 = (props) => {
  return (
    <td>
      <div className="grid-btn-div">
        <button className="grid-btn-action" onClick={() => props.handleChangeAttedance(props.dataItem)}>
          <p>{(props.dataItem.attendance) ? props.t("assembliesDetailView.grid.btns.unmark.attendance") : props.t("assembliesDetailView.grid.btns.mark.attendance")}</p>
        </button>
      </div>
      <div className="grid-btn-arrow" onClick={() => props.handleChangeAttedance(props.dataItem)}>
        <img alt="assemblies-arrow" src={ArrowBtnMobile} />
      </div >
    </td >
  );
};

const AssembliesDetailView = (props) => {
  const { t } = useTranslation()
  const history = useHistory()

  let {
    isLoading,
    titleHeader,
    user,
    showLoadingRequesting,
    showCompletedRequesting,
    showErrorRequesting,
    messageComplete,
    messageError,
    toggleErrorRequestingFalse,
    toggleCompletedRequesting,
    toggleLoadingRequesting,
    membersChat,
    usersChat,
    conversation,
    createMessage,
    handleInputChangeChat,
    assembly,
    statusWorkflow,
    showBtnNextStatus,
    showBtnBackStatus,
    nameBtnNext,
    backBtnName,
    cancelBtnName,
    showBtnCancelStatus,
    showInvitations,
    showChat,
    showPdf,
    guests,
    showBtnAddGuest,
    setGuests,
    changeStatusWorkflow,
    showBtnToManageAssembly,
    sendManageAssembly,
    updateAttendanceGuestAssembly
  } = props

  const preferredLanguage = LocalStorageService.retrieveItem("preferredLanguage")
  const language = preferredLanguage || "es"
  moment.locale(language);

  const validator = ProfileValidator(t)
  const is620 = useMediaQuery("(max-width:620px)");
  const is720 = useMediaQuery("(max-width:720px)");

  let pdfURL = `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_DEFAULT_PDF}`
  const pdfAws = useMemo(() => <PdfReader className="pdfReader" url={pdfURL} awsURL src={pdfURL}  ></PdfReader>, [pdfURL])
  let ENV = process.env

  const [guestsGrid, setGuestGrid] = useState([])
  const [assemblyName, setAssemblyName] = useState('')
  const [assemblyStatus, setAssemblyStatus] = useState('')
  const [assemblyDate, setAssemblyDate] = useState('')
  const [assemblyUserCreated, setUserCreated] = useState('')
  const [showModalAddGuest, setShowModalAddGuest] = useState(false)
  const [nameNewguest, setNameNewGuest] = useState('')
  const [emailNewguest, setEmailNewGuest] = useState('')
  const [phoneNewguest, setPoneNewGuest] = useState('')
  const [guestIndex, setGuestIndex] = useState(0)
  const [errorName, setErrorName] = useState(false)
  const [errorEmail, setErrorEmail] = useState(false)
  const [errorPhone, setErrorPhone] = useState(false)

  useEffect(() => {
    if (!guests || guests.length === 0) return
    setGuestGrid(guests)
  }, [guests])

  useEffect(() => {
    if (!assembly) return
    let convertDate = convertToStandarDate(assembly.date, language)

    setAssemblyName(assembly.name)
    setAssemblyStatus(assembly.status)
    setAssemblyDate(convertDate)
    setUserCreated(assembly.userCreatedName)
  }, [assembly])

  let AllHeadersColumns = (props) => <HeaderColumns {...props} t={t} />
  let CellColumnOne = (props) => <CellColumnName {...props} t={t} />
  let CellColumnTwo = (props) => <CellColumnType {...props} t={t} />
  let CellColumnThree = (props) => <CellColumnDate {...props} t={t} />
  let CellColumnFour = (props) => <CellColumnAttendance {...props} t={t} />
  let CellColumnSix = (props) => (statusWorkflow === Number(ENV.REACT_APP_WORKFLOW__ASSEMBLY_STATUS_316140)) ? <CellColumnBtns140 {...props} t={t} handleChangeAttedance={handleChangeAttedance} /> : <CellColumnBtns {...props} t={t} setShowModalAddGuest={setShowModalAddGuest} setPoneNewGuest={setPoneNewGuest} setEmailNewGuest={setEmailNewGuest} setNameNewGuest={setNameNewGuest} setGuestIndex={setGuestIndex} statusWorkflow={statusWorkflow} deleteGuest={deleteGuest} />

  let widthCellOne = '150px'
  let widthCellTwo = '70px'
  let widthCellThree = '70px'
  let widthCellFour = '50px'
  let widthCellSix = '50px'

  const handleChangeInputs = (e, type, setValue, setError) => {
    setError(false)

    let value = e.target.value

    if (type === 'number') {
      value = Number(value)
      if (isNaN(value)) return
    }

    setValue(value)
  }

  const saveNewGuest = () => {
    if (guestIndex) {
      let guestsCopy = JSON.parse(JSON.stringify([...guests]))
      guestsCopy[guestIndex] = {
        ...guestsCopy[guestIndex],
        email: emailNewguest,
        phone: phoneNewguest,
        representativeName: nameNewguest
      }
      setGuestIndex(0)
      setGuests(guestsCopy)
      setCloseAddGuest()
      return
    }
    let nameValid = validator.nameValidator(nameNewguest);
    if (!nameNewguest || nameValid !== "") {
      setErrorName(true)
      return
    }

    let emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!emailNewguest.match(emailRegex)) {
      setErrorEmail(true)
      return
    }

    if (phoneNewguest) {
      let phoneValid = validator.phoneNumberValidator(phoneNewguest);
      if (phoneValid !== "") {
        setErrorPhone(true)
        return
      }
    }

    let userSessionId = (user && user.userMetaData && user.userMetaData.userMifirma && user.userMetaData.userMifirma.id) ? user.userMetaData.userMifirma.id : 0
    let today = new Date()
    let dateFormatted = convertToStandarDate(today, language)
    let newGuest = {
      id: null,
      assemblyId: assembly.id,
      shareholderId: null,
      guestAssemblyId: null,
      status: null,
      notes: null,
      userCreated: userSessionId,
      createdDate: "",
      participation: "",
      invitationNotes: "",
      invitationName: "",
      representativeName: nameNewguest,
      phone: phoneNewguest,
      email: emailNewguest,
      rfcLegalEntity: "",
      rfcIndividual: "",
      invitationNote: "",
      dateFormatted,
      type: t("assembliesDetailAction.label.guest.type.guest")
    }

    let newGuests = [...guests]
    newGuests.push(newGuest)
    setGuests(newGuests)
    setCloseAddGuest()
  }

  const setCloseAddGuest = () => {
    setNameNewGuest('')
    setEmailNewGuest('')
    setPoneNewGuest('')
    setErrorName(false)
    setErrorEmail(false)
    setErrorPhone(false)
    setShowModalAddGuest(false)
  }

  const deleteGuest = (guest) => {
    let copyGuests = [...guests]
    let newGuest = copyGuests.filter(cg => cg.email !== guest.email)
    setGuests(newGuest)
    setGuestGrid(newGuest)
  }

  const handleChangeStatusWorkflow = (action) => {

    let params = {
      action
    }
    changeStatusWorkflow(params)
  }

  const handleChangeAttedance = (guestSelected) => {
    let invitationId = 0
    let attendance = false
    let copyGuests = [...guests]
    let newGuests = copyGuests.map(guest => {
      if (guest.email === guestSelected.email) {
        guest.attendance = !guest.attendance
        guest.attendanceValue = (guest.attendance) ? t("assembliesDetailAction.label.attendance.yes") : t("assembliesDetailAction.label.attendance.no")
        invitationId = guest.id
        attendance = guest.attendance
      }
      return guest
    })

    setGuests(newGuests)
    updateAttendanceGuestAssembly(invitationId, attendance)
  }

  if (isLoading) return <SimpleLoading />

  return (
    <div className='standard-wrapper'>
      <div className='assembliesDetailView-header'>
        <HeaderHLPure title={titleHeader} />
      </div>
      <div className='assembliesDetailView-body'>
        <BoxSomeHeadersGLPure
          titleOne={t("assembliesDetailView.labels.name.assembly")}
          subtitleOne={assemblyName}
          titleTwo={t("assembliesDetailView.labels.status.assembly")}
          subtitleTwo={assemblyStatus}
          titleThree={t("assembliesDetailView.labels.date.assembly")}
          subtitleThree={assemblyDate}
          titleFour={t("assembliesDetailView.labels.applicant.assembly")}
          subtitleFour={assemblyUserCreated}
        />
        {
          showBtnAddGuest && (
            <div className='assembliesDetailView-btn-add-guest'>
              <ButtonAddHLPure
                nameBtn={t("assembliesDetailView.btns.add.guest")}
                iconAdd
                onClickBtn={() => setShowModalAddGuest(true)}
              />
            </div>
          )
        }
        {
          showInvitations && (
            <div className="assembliesPrincipalView-grid">
              <GridSelectionHLPure
                skip={0}
                take={6}
                dataGrid={guestsGrid}

                columnOne
                titleRow1={t("assembliesDetailView.grid.title.1")}
                cellColumnOne={CellColumnOne}
                headerColumnOne={AllHeadersColumns}
                widthColumnOne={widthCellOne}
                minResizableWidth1={"auto"}

                columnTwo={(is620) ? false : true}
                titleRow2={t("assembliesDetailView.grid.title.2")}
                cellColumnTwo={CellColumnTwo}
                headerColumnTwo={AllHeadersColumns}
                widthColumnTwo={widthCellTwo}
                minResizableWidth2={widthCellTwo}

                columnThree={(is720) ? false : true}
                titleRow3={t("assembliesDetailView.grid.title.3")}
                cellColumnThree={CellColumnThree}
                headerColumnThree={AllHeadersColumns}
                widthColumnThree={widthCellThree}
                minResizableWidth3={widthCellThree}

                columnFour={(statusWorkflow === Number(ENV.REACT_APP_WORKFLOW__ASSEMBLY_STATUS_316140) && !is620) ? true : false}
                titleRow4={t("assembliesDetailView.grid.title.4")}
                cellColumnFour={CellColumnFour}
                headerColumnFour={AllHeadersColumns}
                widthColumnFour={widthCellFour}
                minResizableWidth4={widthCellFour}

                columnSix={(statusWorkflow === Number(ENV.REACT_APP_WORKFLOW__ASSEMBLY_STATUS_316130)) ? false : true}
                titleRow6={t("assembliesDetailView.grid.title.5")}
                cellColumnSix={CellColumnSix}
                headerColumnSix={AllHeadersColumns}
                widthColumnSix={widthCellSix}
                minResizableWidth6={widthCellSix}
              />
            </div>
          )
        }
        <div className='assembliesDetailView-elements'>
          {
            showChat && (
              <div className=''>
                <Grid className="validateFreelanceView-headerUsersChat">
                  <span className="validateFreelanceView-titleGrid">
                    {t("validateFreelanceView.title.chat")}
                  </span>
                  <div className="validateFreelanceView-containersAvatars">
                    {membersChat.map((item, index) => (
                      <div>
                        <Tooltip
                          openDelay={600}
                          position="bottom"
                          anchorElement="target"
                          tooltipClassName="tooltipGeneralStyle"
                        >
                          <div>
                            <img
                              title={item.name}
                              key={index}
                              src={
                                item.avatarUrl && item.avatarUrl !== ""
                                  ? item.avatarUrl
                                  : newProfileIcon
                              }
                              className="validateFreelanceView-avatar"
                              alt={item.name}
                            />
                          </div>
                        </Tooltip>
                      </div>
                    ))
                    }
                  </div>
                </Grid>
                <ChatBoxGLPure
                  user={usersChat}
                  conversation={conversation}
                  widthChat={1200}
                  heightChat={300}
                  placeholderChat={t("chatBoxGLPure.placeholder")}
                  handleInputChange={handleInputChangeChat}
                  createMessage={createMessage}
                />
              </div>
            )
          }
          {
            showPdf && (
              <div>
                {pdfAws}
              </div>
            )
          }
        </div>
        <div className='assembliesDetailView-btns'>
          <ButtonHLPure
            nameBtn={t("button.back")}
            onClickBtn={() => history.replace("/")}
          />
          {
            showBtnToManageAssembly && (
              <ButtonHLPure
                nameBtn={t("assembliesDetailView.btns.send.manage.asssembly")}
                onClickBtn={() => sendManageAssembly()}
              />
            )
          }
          {
            showBtnBackStatus && (
              <ButtonHLPure
                nameBtn={backBtnName}
                onClickBtn={() => handleChangeStatusWorkflow('back')}
              />
            )
          }
          {
            showBtnCancelStatus && (
              <ButtonHLPure
                nameBtn={cancelBtnName}
                onClickBtn={() => handleChangeStatusWorkflow('defined')}
              />
            )
          }
          {
            showBtnNextStatus && (
              <ButtonHLPure
                primary
                nameBtn={nameBtnNext}
                onClickBtn={() => handleChangeStatusWorkflow('next')}
              />
            )
          }
        </div>
      </div>
      <div className='assembliesView-footer'>
        <PromotionalFooterPure />
      </div>
      {
        showModalAddGuest && (
          <DialogPdfHLPure
            width={600}
            height={480}
            heightBody={300}
            title={t("assembliesDetailView.modal.add.guest.title")}
            handleSubmitProfile={() => saveNewGuest()}
            saveBtn={t("button.save")}
            canelBtn={t("button.cancel")}
            cancel={() => setCloseAddGuest()}
          >
            <div className='assembliesDetailView-body-modal'>
              <InputHLPure
                labelInput={t("assembliesDetailView.labels.email")}
                inputActive
                valueInput={emailNewguest}
                handleChangeInput={(e) => handleChangeInputs(e, 'string', setEmailNewGuest, setErrorEmail)}
                typeInput={"text"}
                errorInput={errorEmail}
                errorInputText={t("businessAdministrationDetailView.errorEmail")}
                required
              />
              <InputHLPure
                labelInput={t("assembliesDetailView.labels.name")}
                inputActive
                valueInput={nameNewguest}
                handleChangeInput={(e) => handleChangeInputs(e, 'string', setNameNewGuest, setErrorName)}
                typeInput={"text"}
                errorInput={errorName}
                errorInputText={t("registration.validator.nameValidator")}
                required
              />
              <InputHLPure
                labelInput={t("assembliesDetailView.labels.phone")}
                inputActive
                valueInput={phoneNewguest}
                handleChangeInput={(e) => handleChangeInputs(e, 'number', setPoneNewGuest, setErrorPhone)}
                typeInput={"string"}
                errorInput={errorPhone}
                errorInputText={t("registration.validator.phoneValidato")}
              />
            </div>
          </DialogPdfHLPure>
        )
      }

      <DialogSystemGLPure
        showLoadingRequesting={showLoadingRequesting}
        toggleLoadingRequesting={toggleLoadingRequesting}

        showCompletedRequesting={showCompletedRequesting}
        toggleCompletedRequesting={toggleCompletedRequesting}
        messageComplete={messageComplete}

        showErrorRequesting={showErrorRequesting}
        toggleErrorRequesting={toggleErrorRequestingFalse}
        messageError={messageError}
      />
    </div>
  )
}

export default AssembliesDetailView